import React from 'react';
import { IconButton, Stack, SxProps } from '@mui/material';
import { DeleteOutline } from '@mui/icons-material';
import { ConfirmationModalType } from 'services/modals/constants';
import { useConfirmationModal } from 'services/modals/hooks';
import { AutomationFormItem } from 'modules/analyse/types/AutomationFormItem';
import { RuleSettingConversationAutomationItem } from 'modules/analyse-automations/components/RuleSettingConversationAutomationItem';
import { RuleSettingAnalysisScoreAutomationItem } from 'modules/analyse-automations/components/RuleSettingAnalysisScoreAutomationItem';
import { getAnalysisAutomationType } from 'modules/analyse-automations/utils/getAnalysisAutomationType';
import { RuleSettingAnalysisNotMetAutomationItem } from 'modules/analyse-automations/components/RuleSettingAnalysisNotMetAutomationItem';

export const rulesetInputWidth = '350px';

export const rulesetInputContainer: SxProps = {
  backgroundColor: 'white'
};

type Props = {
  index: number;
  setFieldValue: (field: string, value: any) => void;
  analysisAutomationItem: AutomationFormItem;
  removeRuleItem: () => void;
};

export const RuleSettingItem: React.FC<Props> = ({
  index,
  analysisAutomationItem,
  setFieldValue,
  removeRuleItem
}) => {
  const analysisAutomationType = getAnalysisAutomationType(
    analysisAutomationItem
  );

  const { showModal } = useConfirmationModal();

  const onDeleteClick = () => {
    showModal({
      title: 'Delete rule?',
      message: 'This cannot be undone',
      onDestructiveConfirm: removeRuleItem,
      modalType: ConfirmationModalType.DESTRUCTIVE,
      cancelText: 'Cancel',
      destructiveText: 'Delete'
    });
  };

  switch (analysisAutomationType) {
    case 'conversationScore':
      return (
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="start"
        >
          <RuleSettingConversationAutomationItem
            analysisAutomationItem={analysisAutomationItem}
            onChangeAnalysisAutomationItem={(analysisAutomationItem) => {
              setFieldValue(`[${index}]`, analysisAutomationItem);
            }}
          />
          <IconButton color="error" size="small" onClick={onDeleteClick}>
            <DeleteOutline />
          </IconButton>
        </Stack>
      );
    case 'analysisScore':
      return (
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="start"
        >
          <RuleSettingAnalysisScoreAutomationItem
            analysisAutomationItem={analysisAutomationItem}
            onChangeAnalysisAutomationItem={(analysisAutomationItem) => {
              setFieldValue(`[${index}]`, analysisAutomationItem);
            }}
          />
          <IconButton color="error" size="small" onClick={onDeleteClick}>
            <DeleteOutline />
          </IconButton>
        </Stack>
      );
    case 'analysisUnmet':
      return (
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="start"
        >
          <RuleSettingAnalysisNotMetAutomationItem
            analysisAutomationItem={analysisAutomationItem}
            onChangeAnalysisAutomationItem={(analysisAutomationItem) => {
              setFieldValue(`[${index}]`, analysisAutomationItem);
            }}
          />
          <IconButton color="error" size="small" onClick={onDeleteClick}>
            <DeleteOutline />
          </IconButton>
        </Stack>
      );
  }
};
